(function() {
  const FREE_SHIPPING_THRESHOLD = 100.00; // montant de livraison gratuite en euros

  function formatPrice(euros) {
    return euros.toFixed(2).replace('.', ',') + ' €';
  }

  function updateBanner() {
    fetch('/cart.json')
      .then(res => res.json())
      .then(cart => {
        const total = cart.total_price / 100;
        const banner = document.getElementById('free-shipping-banner');
        if (!banner) return;

        const remaining = (FREE_SHIPPING_THRESHOLD - total).toFixed(2);

        if (remaining > 0) {
          banner.style.display = 'block';
          banner.textContent = `Encore ${formatPrice(parseFloat(remaining))} pour profiter de la livraison gratuite !`;
        } else {
          banner.style.display = 'block';
          banner.textContent = `🎉 Livraison gratuite !`;
        }
      })
      .catch(() => {});
  }

  document.addEventListener('DOMContentLoaded', updateBanner);
  document.addEventListener('cart:updated', updateBanner);
  document.addEventListener('ajaxProduct:added', updateBanner);
})();
